import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FertilizationBalanceSetting } from 'src/app/shared/models';

@Component({
  selector: 'app-fertilization-balance-settings-participation-confirm-dialog',
  templateUrl: './fertilization-balance-settings-cancellation-confirm-dialog.component.html',
  styleUrls: ['./fertilization-balance-settings-cancellation-confirm-dialog.component.scss'],
  standalone: false,
})
export class FertilizationBalanceSettingsCancellationConfirmDialogComponent {
  dialogRef = inject<MatDialogRef<FertilizationBalanceSettingsCancellationConfirmDialogComponent>>(MatDialogRef);
  data = inject<{
    fertilizationBalanceSettings: FertilizationBalanceSetting[];
}>(MAT_DIALOG_DATA);


  confirm() {
    this.dialogRef.close(true);
  }

  cancel() {
    this.dialogRef.close(false);
  }
}
